<script type="text/javascript">
	import Icon from "./icon.svelte";
	export let selected = {};
	export let values = [];

	let dropdownComponent, dropdownInnerContainer;

	import { createEventDispatcher } from 'svelte';
	import { beforeUpdate, afterUpdate } from 'svelte';

	const dispatch = createEventDispatcher();

	let opened = false;

	let toggleOpen = ()=>{opened=!opened;if (opened) onOpen();}
	let open = ()=>{opened=true;onOpen();}

	afterUpdate(() => {
		var rect = dropdownComponent.getBoundingClientRect();
		var dropdownRect = dropdownInnerContainer.getBoundingClientRect();
		if (window.innerWidth > 1015 && rect.left + dropdownInnerContainer.offsetWidth > window.innerWidth - 50){
					dropdownInnerContainer.style.left = (window.innerWidth - (dropdownInnerContainer.offsetWidth+50))+"px";
				}
	});

	function onOpen(){
		dropdownInnerContainer.style.minWidth = null;
		dropdownInnerContainer.style.top = null;
		dropdownInnerContainer.style.left = null;
		
			if (window.innerWidth > 1015){
				var rect = dropdownComponent.getBoundingClientRect()

				dropdownInnerContainer.style.left = rect.left+"px";
				dropdownInnerContainer.style.top = (rect.top+dropdownComponent.offsetHeight)+"px";

				dropdownInnerContainer.style.minWidth = dropdownComponent.offsetWidth+"px";

				var dropdownRect = dropdownInnerContainer.getBoundingClientRect();

			}
		}
</script>

<button class="dropdown-component" bind:this={dropdownComponent} on:click={e=>toggleOpen()}><slot></slot></button>



<button class="dropdown-backdrop" class:show={opened} on:click={e=>opened=false}></button>

<div class="dropdown-inner-container" bind:this={dropdownInnerContainer} class:show={opened} on:click={e=>opened=false}>
<ul class="dropdown-inner" class:show={opened}>
		{#each values as value}
			<li class:active={value==selected}
			on:click={()=>{
				opened = false;
				selected = value;

				dispatch('change',{value:value});
			}}>
				<a class="dropdown-value" href={value.link ? value.link : "#"} on:click|preventDefault={e=>{}} class:inverse={$$props.iconInverse}>
					<div class="icon-placeholder">
						{#if value.icon}
							<Icon w=15 h=15 i={value.icon} />
						{/if}
					</div>
					<span class="label">{value.label}</span>
				</a>
			</li>
		{/each}
	</ul>
</div>

<style type="text/css">

	.dropdown-backdrop{
		display: none;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		min-width: 99vw;
		height: 100%;
		min-height: 99vh;
		background: rgba(0,0,0,.5);
		z-index: 100;
		backdrop-filter: blur(1px);
		border: none;
	}


	.dropdown-inner.show,
	.dropdown-backdrop.show{
		display: block;
	}
	.dropdown-inner-container.show{display: flex;}

	
	.dropdown-inner-container{
		position: fixed;
		display: none;
		z-index: 100;
	}
	.dropdown-inner{

		max-height: 85vh;
		overflow-y: scroll;
		width: 100%;
		list-style: none;
		border-radius: 4px;
		background: rgba(51, 60, 81, 0.6);
		border: 1px solid #333C51;
		box-shadow: 0px 4px 28px #000000;
		color: white;
		backdrop-filter: blur(5px);
	}

	.dropdown-component{
		background: none;
		
		border: none;
		padding: 0;
		cursor: pointer;
		font-family: "Geometria", sans-serif;
		width: 100%;
	}
	.dropdown-inner > li{
		margin-left: -40px;
		cursor: pointer;
	}
	.dropdown-inner > li:hover,
	.dropdown-inner > li.active{
		background: #AF71DC;
		transition: .1s linear;
	}
	.dropdown-inner > li > .dropdown-value{
		display: flex; align-items: center;
		margin: 0 15px;
		padding: 10px 0;
		color: white;
		text-decoration: none;
	}
	.dropdown-inner > li:not(:last-child) > .dropdown-value{
		border-bottom: 1px solid rgba(255,255,255,.2);
	}
	.dropdown-inner > li > .dropdown-value > .icon-placeholder{
		width: 23px;
		height: 23px;

		background: rgba(255,255,255,.1);
		padding: 5px;
		box-sizing: border-box;
		border-radius: 4px;
		margin-right: 10px;

		display: flex;
		justify-content: center;
		align-items: center;
	}

	.dropdown-inner > li > .dropdown-value.inverse > .icon-placeholder{
		margin-right: 0;
		margin-left: 10px;
	}

	.dropdown-inner > li > .dropdown-value.inverse{
		flex-direction: row-reverse;
		justify-content: space-between;
	}

	@media(max-width: 1015px){
		.dropdown-inner-container{
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;	
			align-items: center;
			justify-content: center;	
		}
		.dropdown-inner{
			width: 80vw;
		}
		.dropdown-inner > li > .dropdown-value{
			display: flex; align-items: center;
			justify-content: flex-start;
			width: 80vw;
			margin: 0 15px;
			padding: 20px 0;
		}
	}
	
</style>